/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrivateNoteRequest
 */
export interface PrivateNoteRequest {
    /**
     * Text content of the private note
     * @type {string}
     * @memberof PrivateNoteRequest
     */
    text: string;
    /**
     * ID of a message this note is related to
     * @type {string}
     * @memberof PrivateNoteRequest
     */
    relatedMessageId?: string;
    /**
     * List of media attachment IDs to include with the note
     * @type {Array<string>}
     * @memberof PrivateNoteRequest
     */
    attachmentIds: Array<string>;
}

/**
 * Check if a given object implements the PrivateNoteRequest interface.
 */
export function instanceOfPrivateNoteRequest(value: object): value is PrivateNoteRequest {
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('attachmentIds' in value) || value['attachmentIds'] === undefined) return false;
    return true;
}

export function PrivateNoteRequestFromJSON(json: any): PrivateNoteRequest {
    return PrivateNoteRequestFromJSONTyped(json, false);
}

export function PrivateNoteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrivateNoteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
        'relatedMessageId': json['relatedMessageId'] == null ? undefined : json['relatedMessageId'],
        'attachmentIds': json['attachmentIds'],
    };
}

export function PrivateNoteRequestToJSON(json: any): PrivateNoteRequest {
    return PrivateNoteRequestToJSONTyped(json, false);
}

export function PrivateNoteRequestToJSONTyped(value?: PrivateNoteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
        'relatedMessageId': value['relatedMessageId'],
        'attachmentIds': value['attachmentIds'],
    };
}

